/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpagedetailreference3Inputs */

const en_ticketpagedetailreference3 = /** @type {(inputs: Ticketpagedetailreference3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order number`)
};

const de_ticketpagedetailreference3 = /** @type {(inputs: Ticketpagedetailreference3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestellnummer`)
};

/**
* | output |
* | --- |
* | "Order number" |
*
* @param {Ticketpagedetailreference3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpagedetailreference3 = /** @type {((inputs?: Ticketpagedetailreference3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpagedetailreference3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpagedetailreference3(inputs)
	return de_ticketpagedetailreference3(inputs)
});
export { ticketpagedetailreference3 as "ticketPageDetailReference" }